var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      fancy: _vm.fancy,
      label: _vm.label,
      open: "",
      items: _vm.foundCars,
      "input-delay": 500,
      "empty-on-focus": "",
      icon: "times",
    },
    on: {
      "icon-click": function ($event) {
        return _vm.clearCar()
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      "item-click": function ($event) {
        return _vm.selectCar($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _c("div", [
              _vm._v(_vm._s(p.item.Plate) + " "),
              _vm.includeMileageInLabel
                ? _c("span", { staticClass: "mileage" }, [
                    _vm._v(_vm._s(p.item.Mileage) + "km"),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "smaller" }, [
              _vm._v(" " + _vm._s(p.item.Chassis) + " "),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }